import { render, staticRenderFns } from "./Hanoi5G.vue?vue&type=template&id=090f23a4&"
import script from "./Hanoi5G.vue?vue&type=script&lang=js&"
export * from "./Hanoi5G.vue?vue&type=script&lang=js&"
import style0 from "./Hanoi5G.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports